import { Component, ElementRef, ViewChild } from '@angular/core';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/logger.service';
import { UserApiService } from '../../services/user-api.service';
import { Router } from '@angular/router';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { SelectDrug } from '../../models/select-drug';
import * as _ from 'lodash-es';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { TabelPaging } from '../../interfaces/table';
import { PCTableActionInputModel } from '../../models/pc-table-action-input-model';
import { NewCalendarService } from 'src/app/services/new-calender-service';
import { PCTableComponent } from '../../components/pctable/pctable.component';
import { Stock } from '../../models/stock';
import { PcsettingModalComponent } from '../../components/pcsetting-modal/pcsetting-modal.component';

@Component({
  selector: 'app-stock',
  templateUrl: './stock.component.html',
  styleUrls: ['./stock.component.css'],
})
export class StockComponent {
  [x: string]: any;
  public item: any;
  public Value: any;
  public searchedItem: string;
  public drugList: SelectDrug[];
  backendJson: any;
  index: any;
  i: any;
  stock: any;

  public constructor(
    private apiService: UserApiService,
    private modalService: NgbModal,
    private logger: LoggerService,
    private responseService: CustomizeResponseService
  ) {
    this.editable = true;
    this.deleteable = true;
    this.searchedItem = '';
    this.drugList = [];
    this.requestModel = new PCSearchRequestModel();

    this.action = new PCTableActionInputModel(
      [
        {
          name: 'needsBye',
          className: 'yellow',
          icon: 'fa-solid fa-battery-quarter',
        },
        {
          name: 'closeEXP',
          className: 'pink',
          icon: 'fa-solid fa-clock-rotate-left',
        },
        { name: 'All', className: 'btn-outline-primary', icon: 'fa fa-upload' },
        {
          name: 'Reload',
          className: 'btn-outline-primary',
          icon: 'bx bx-refresh',
        },
        {
          name: 'Settings',
          className: 'btn-outline-primary',
          icon: 'bx bx-cog',
        },
        {
          name: 'Print',
          className: 'btn-outline-primary',
          icon: 'bx bx-printer',
        },
        {
          name: 'Explanation',
          className: 'btn-outline-primary',
          icon: 'bx bx-question-mark',
        },
        {
          name: 'backtoFirstPage',
          className: 'btn-outline-primary',
          icon: 'fa fa-mail-reply',
        },
      ],
      'انبار مرکزی',
      []
    );

    this.generateUrl();
    this.getStockType();
    this.getStocks();
    this.getEntity();
  }

  public thisStock?: Stock;
  public level: number = 1;
  public loading: boolean = false;
  public stocks: Stock[] = [];
  public stockTypes: any[] = [];
  public newItem: any = {
    name: '',
    nameMessage: undefined,
    type: '',
    typeMessage: undefined,
    id: '',
    isEditable: false,
  };

  public activeAdd: boolean = true;
  public editable: boolean;
  public deleteable: boolean;
  public openAddModal: boolean = false;
  public modalSuccessConfirm: boolean = false;

  public settingModal = new PCTableOutputModel('Settings', null);

  public data?: PCTableInputModel;
  public requestModel: PCSearchRequestModel;
  public paging?: TabelPaging;
  public endPointUrl?: string;
  public actionName: string = `Search`;
  public action: PCTableActionInputModel;
  public fields: any[] = [];
  public thisValue: any;
  public today: any;
  public OpenSettingModal: boolean = true;

  @ViewChild('modalContent') modalContent!: any;
  @ViewChild(PCTableComponent) pcTableComponent!: PCTableComponent;
  @ViewChild(PcsettingModalComponent)
  pcsettingModalComponent!: PcsettingModalComponent;
  @ViewChild('firstStep') firstStep!: ElementRef;
  @ViewChild('secondStep') secondStep!: ElementRef;

  public stockItems: any[] = [];

  public search: string = ``;

  public getEntity() {
    this.apiService
      .getEntity(
        new ApiRequestModel(
          'Stock',
          null,
          undefined,
          'InventoryDetail',
          'InventoryDetail'
        )
      )
      .subscribe(
        (result) => {
          this.logger.addResponseLog('Inventory', result, `Get Entity`);
          if (result.succeeded) {
            let fields = this.apiService.convertStringToBoolean(
              result.data.fields
            );

            fields.forEach((element) => {
              element.camelCaseName = this.apiService.camelCase(
                element.fieldName
              );
            });

            this.fields = fields;
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => {}
      );
  }

  public getStocks() {
    try {
      this.loading = true;

      let url = `Stock?pageNumber=1&pageSize=30&paging=true&orderBy=&direction=asc`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (!result.data) {
            this.stocks = [];
          } else {
            this.stocks = result.data.items;

            setTimeout(() => {
              let selectStockPage = document.getElementById('selectStockPage');
              if (selectStockPage) {
                selectStockPage.classList.remove('animate__backInDown');
              }
            }, 2 * 1000);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public getStockType() {
    try {
      this.loading = true;

      let url = `StockType?pageNumber=1&pageSize=30&paging=true&orderBy=&direction=asc`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (!result.data) {
            this.stockTypes = [];
          } else {
            this.stockTypes = result.data.items.map((current) => ({
              id: current.id,
              name: current.name,
              persianName: current.persianName,
            }));
          }

          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public remove(index) {
    this.stock.splice(index, 1);
  }

  public requestNew() {
    if (this.newItem.name == null) {
      return;
    }

    if (this.newItem.name.lenght < 3) {
      return;
    }

    if (!this.newItem.type) {
      return;
    }

    this.stocks.push(this.newItem);
  }

  public validateAdd() {
    let isValid = true;

    if (this.newItem.name == null || this.newItem.name == '') {
      this.newItem.nameMessage = 'نام انبار اجباری است';
      isValid = false;
    } else {
      let exactMatch = new RegExp(/^([آ-ی]|[a-z]|[A-Z]| ){3,20}$/);
      if (!exactMatch.test(this.newItem.name)) {
        this.newItem.nameMessage =
          'در نام انبار فقط میتوانید از حروف استفاده کنید';
        isValid = false;
      } else {
        this.newItem.nameMessage = undefined;
      }
    }

    if (this.newItem.type == null || this.newItem.type == '') {
      this.newItem.typeMessage = 'وارد کردن نوع انبار اجباری است ';
      isValid = false;
    } else {
      this.newItem.typeMessage = undefined;
    }

    return isValid;
  }

  public validateEdit(stock: any) {
    let isValid = true;

    if (stock.name == null || stock.name == '') {
      this.newItem.nameMessage = 'نام انبار اجباری است';
      isValid = false;
    } else {
      let exactMatch = new RegExp(/^([آ-ی]|[a-z]|[A-Z]| ){3,20}$/);
      if (!exactMatch.test(stock.name)) {
        this.newItem.nameMessage = 'لطفاً فقط از حروف استفاده کنید';
        isValid = false;
      } else {
        this.newItem.nameMessage = undefined;
      }
    }

    if (stock.type == null || stock.type == '') {
      this.newItem.typeMessage = 'وارد کردن نوع انبار اجباری است ';
      isValid = false;
    } else {
      this.newItem.typeMessage = undefined;
    }

    return isValid;
  }

  public add() {
    try {
      if (!this.validateAdd()) {
        return;
      }

      this.loading = true;

      let url = `Stock`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }
      var backendData = {
        title:this.newItem.name,
        isActiveDirectSell:false,
        stockTypeId:this.newItem.type
      };

      this.apiService.postItem(new ApiRequestModel(url, backendData)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `post item`);
          this.getStocks();
          this.activeAdd = true;

          this.newItem = {
            name: '',
            type: null,
          };
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, false);
    }
  }

  public openEdit(stock: any) {
    this.newItem.typeMessage = undefined;
    this.newItem.nameMessage = undefined;
    stock.isEditable = true;
  }

  public edit(stock: any) {
    try {
      if (!this.validateEdit(stock)) {
        return;
      }

      this.loading = true;

      let url = `Stock/${stock.id}`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }
      var backendData = {};

      backendData['stockTypeId'] = stock.type;
      backendData['name'] = stock.name;
      backendData['persianName'] = stock.name;

      this.apiService
        .patchItem(new ApiRequestModel(url, backendData))
        .subscribe(
          (result) => {
            this.logger.addResponseLog(url, result, `post item`);
            this.getStocks();
            this.activeAdd = true;

            this.newItem = {
              name: '',
              type: null,
            };
          },
          (error) => {
            this.logger.addError(error, false);
          },
          () => {}
        );
    } catch (e) {
      this.logger.addException(e, false);
    }
  }

  public getButtonData(stock?: any): void {
    try {
      if (stock != null) {
        this.thisStock = stock;
        this.action.title = stock.name;
        this.generateButtonUrl();
      }

      if (
        !this.apiService.tokenValidation(new ApiRequestModel(this.endPointUrl!))
      ) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(this.endPointUrl!)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl!, result, `Get All`);
          if (result.succeeded) {
            this.today = result.dateTime;
            let firstItemOnPage = 1;
            if (result.data?.firstItemOnPage) {
              firstItemOnPage = result.data?.firstItemOnPage;
            }

            if (result.data?.pageCount! < result.data?.pageNumber!) {
              this.requestModel.pageNumber = 1;
            }

            this.data = new PCTableInputModel(
              result.data?.items,
              [],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            this.paging = this.responseService.customizePaging(result);

            setTimeout(() => {
              this.pcTableComponent.InitPage();
            }, 700);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
    }

    if (stock != null) {
      let selectStockPage = document.getElementById('selectStockPage');
      if (selectStockPage) {
        selectStockPage.classList.add('animate__backOutDown');
      }

      setTimeout(() => {
        this.level++;
      }, 700);

      setTimeout(() => {
        let selectStockPage = document.getElementById('StockDetail');
        if (selectStockPage) {
          selectStockPage.classList.remove('animate__backInDown');
        }
      }, 2 * 1000);
    }
  }

  public gotoDetail(stock?: Stock) {
    this.getData(stock);
    this.gotoDetailUI();
  }

  private getData(stock?: Stock): void {
    try {
      if (stock == null) {
        if (this.thisStock == null) {
          this.logger.addError('UnknownError', false);
          return;
        } else {
          stock = _.cloneDeep(this.thisStock);
        }
      }

      this.loading = true;

      this.generateTopButton(stock!);

      this.generateUrl();

      if (
        !this.apiService.tokenValidation(new ApiRequestModel(this.endPointUrl!))
      ) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(this.endPointUrl!)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl!, result, `Get All`);
          if (result.succeeded) {
            this.today = result.dateTime;
            let firstItemOnPage = 1;
            if (result.data?.firstItemOnPage) {
              firstItemOnPage = result.data?.firstItemOnPage;
            }

            if (result.data?.pageCount! < result.data?.pageNumber!) {
              this.requestModel.pageNumber = 1;
            }

            this.data = new PCTableInputModel(
              result.data?.items,
              [],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            this.paging = this.responseService.customizePaging(result);

            setTimeout(() => {
              this.pcTableComponent.InitPage();
            }, 10);
          }
        },
        (error) => {
          this.loading = false;
          this.apiService.AddErrorLog(error);
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public generateTopButton(stock: Stock) {
    this.thisStock = stock;
    if (stock.isActiveDirectSell) {
      this.action = new PCTableActionInputModel(
        [
          {
            name: 'deactiveDirectSell',
            className: 'btn-outline-danger',
            icon: 'fas fa-times',
          },
          {
            name: 'needsBye',
            className: 'yellow',
            icon: 'fa-solid fa-battery-quarter',
          },
          {
            name: 'closeEXP',
            className: 'pink',
            icon: 'fa-solid fa-clock-rotate-left',
          },
          {
            name: 'All',
            className: 'btn-outline-primary',
            icon: 'fa fa-upload',
          },
          {
            name: 'Reload',
            className: 'btn-outline-primary',
            icon: 'bx bx-refresh',
          },
          {
            name: 'Settings',
            className: 'btn-outline-primary',
            icon: 'bx bx-cog',
          },
          {
            name: 'Print',
            className: 'btn-outline-primary',
            icon: 'bx bx-printer',
          },
          {
            name: 'Explanation',
            className: 'btn-outline-primary',
            icon: 'bx bx-question-mark',
          },
          {
            name: 'backtoFirstPage',
            className: 'btn-outline-primary',
            icon: 'fa fa-mail-reply',
          },
        ],
        stock.title,
        []
      );
    } else {
      this.action = new PCTableActionInputModel(
        [
          {
            name: 'activeDirectSell',
            className: 'btn-outline-primary',
            icon: 'fas fa-check',
          },
          {
            name: 'needsBye',
            className: 'yellow',
            icon: 'fa-solid fa-battery-quarter',
          },
          {
            name: 'closeEXP',
            className: 'pink',
            icon: 'fa-solid fa-clock-rotate-left',
          },
          {
            name: 'All',
            className: 'btn-outline-primary',
            icon: 'fa fa-upload',
          },
          {
            name: 'Reload',
            className: 'btn-outline-primary',
            icon: 'bx bx-refresh',
          },
          {
            name: 'Settings',
            className: 'btn-outline-primary',
            icon: 'bx bx-cog',
          },
          {
            name: 'Print',
            className: 'btn-outline-primary',
            icon: 'bx bx-printer',
          },
          {
            name: 'Explanation',
            className: 'btn-outline-primary',
            icon: 'bx bx-question-mark',
          },
          {
            name: 'backtoFirstPage',
            className: 'btn-outline-primary',
            icon: 'fa fa-mail-reply',
          },
        ],
        stock.title,
        []
      );
    }
  }

  private gotoDetailUI() {
    if (this.firstStep == null || this.secondStep == null) {
      this.logger.addError('UnknownError', false);
      return;
    }

    this.firstStep.nativeElement.classList.remove('animate__backInDown');
    this.firstStep.nativeElement.classList.remove('animate__backOutDown');
    this.secondStep.nativeElement.classList.remove('animate__backInDown');
    this.secondStep.nativeElement.classList.remove('animate__backOutDown');

    this.firstStep.nativeElement.classList.add('animate__backOutDown');

    setTimeout(() => {
      this.firstStep.nativeElement.classList.add('hidden-item');
      this.firstStep.nativeElement.classList.remove('animate__backOutDown');
      this.secondStep.nativeElement.classList.add('animate__backInDown');

      setTimeout(() => {
        this.secondStep.nativeElement.classList.remove('hidden-item');
        setTimeout(() => {
          this.secondStep.nativeElement.classList.remove('animate__backInDown');
        }, 800);
      }, 2);
    }, 800);
  }

  private gotoStockList() {
    if (this.secondStep == null || this.firstStep == null) {
      this.logger.addError('UnknownError', false);
      return;
    }

    this.secondStep.nativeElement.classList.remove('animate__backInDown');
    this.secondStep.nativeElement.classList.remove('animate__backOutDown');
    this.firstStep.nativeElement.classList.remove('animate__backInDown');
    this.firstStep.nativeElement.classList.remove('animate__backOutDown');

    this.secondStep.nativeElement.classList.add('animate__backOutDown');

    setTimeout(() => {
      this.secondStep.nativeElement.classList.add('hidden-item');
      this.secondStep.nativeElement.classList.remove('animate__backOutDown');
      this.firstStep.nativeElement.classList.add('animate__backInDown');

      setTimeout(() => {
        this.firstStep.nativeElement.classList.remove('hidden-item');
        setTimeout(() => {
          this.firstStep.nativeElement.classList.remove('animate__backInDown');
        }, 800);
      }, 2);
    }, 800);
  }

  public searchDrug(): void {
    try {
      this.loading = true;

      if (this.search.length < 3) {
        return;
      }

      if (
        !this.apiService.tokenValidation(new ApiRequestModel(this.endPointUrl!))
      ) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(this.endPointUrl!)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl!, result, `Get All`);
          if (!result.data) {
            this.stockItems = [];
          } else {
            this.stockItems = result.data.items;
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public submitEdit(inputElement: any) {
    try {
      this.loading = true;

      var backentJson = this.createJson(inputElement);

      if (!this.actionName) {
        return;
      }
      const editUrl = `${this.actionName}/${backentJson['Id']}`;
      this.apiService
        .patchItem(new ApiRequestModel(editUrl, backentJson))
        .subscribe(
          (result) => {
            this.modalSuccessConfirm = true;
            this.getData();
          },
          (error) => {
            this.apiService.AddErrorLog(error);
          },
          () => {
            this.loading = false;
            console.log(`Completed!`);
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public createJson(inputElement) {
    var backentJson = {};
    for (let index = 0; index < inputElement.length; index++) {
      const element = inputElement[index];
      let exactMatch = new RegExp(`ArrayList`);
      if (element.fieldDatatype.match(exactMatch) != null) {
        backentJson[element.fieldName] = [];
        if (typeof element.defValue == 'string') {
          backentJson[element.fieldName].push(element.defValue);
        } else if (element.defValue instanceof Array) {
          for (let index = 0; index < element.defValue.length; index++) {
            const defelement = element.defValue[index];
            backentJson[element.fieldName].push(defelement);
          }
        }

        continue;
      }

      exactMatch = new RegExp(`Enum`);
      if (
        element.fieldDatatype.match(exactMatch) != null &&
        element.defValue == ``
      ) {
        backentJson[element.fieldName] = null;
        continue;
      }

      if (element.defValue != null && typeof element.defValue == 'string') {
        exactMatch = new RegExp(`double`);
        if (element.defValue.match(exactMatch) != null) {
          backentJson[element.fieldName] = 0;
          continue;
        }
      }

      backentJson[element.fieldName] = element.defValue;
    }

    return backentJson;
  }

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.loading = true;
        if (this.requestModel.orderBy == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.orderBy != event.data) {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == 'asd') {
          this.requestModel.direction = 'desc';
        }

        this.requestModel.orderBy = event.data;

        this.generateUrl();
        this.getData();
        break;
      case 'Search':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.search = event.data;
        this.generateUrl();
        this.getData();
        break;

      case 'Paging':
        this.loading = true;

        this.requestModel.pageNumber = event.data;
        this.generateUrl();
        this.getData();
        break;

      case 'PageSize':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.pageSize = event.data;
        this.generateUrl();
        this.getData();
        break;

      case 'Reload':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.generateUrl();
        this.getData();
        break;

        case 'Settings':
          this.pcsettingModalComponent.openSettingModal();
          break;
  
        case 'SubmitSetting':
          this.fields = event.data;
          if (this.pcTableComponent) {
            this.pcTableComponent.RebuildColumn();
          } else {
            console.error('PCTableComponent not found');
          }
          break;
  

      case 'Edit':
        this.openModal();
        this.thisValue = event.data;
        break;

      case 'SaveEdit':
        this.openAddModal = false;
        this.submitEdit(event.data);
        break;
      case 'Close':
        this.thisValue = undefined;
        this.openAddModal = false;
        break;

      case 'Successed':
        this.modalSuccessConfirm = false;
        break;

      case 'closeEXP':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.actionName = `CloseToExpire`;
        this.endPointUrl = `InventoryDetail/CloseToExpire?stockId=${this.thisStock?.id}&search=${this.requestModel.search}&pageNumber=${this.requestModel.pageNumber}&pageSize=${this.requestModel.pageSize}&paging=${this.requestModel.paging}&orderBy=${this.requestModel.orderBy}&direction=${this.requestModel.direction}`;
        this.getButtonData();
        break;

      case 'needsBye':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.actionName = `NeedToBy`;
        this.endPointUrl = `InventoryDetail/NeedToBy?stockId=${this.thisStock?.id}&search=${this.requestModel.search}&pageNumber=${this.requestModel.pageNumber}&pageSize=${this.requestModel.pageSize}&paging=${this.requestModel.paging}&orderBy=${this.requestModel.orderBy}&direction=${this.requestModel.direction}`;
        this.getButtonData();
        break;

      case 'All':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.generateUrl();
        this.getData();
        break;

      case 'backtoFirstPage':
        this.gotoStockList();
        break;

      case 'deactiveDirectSell':
        this.changeActiveStatus();
        break;

      case 'activeDirectSell':
        this.changeActiveStatus();
        break;

      default:
        break;
    }
  }

  public changeActiveStatus() {
    try {
      this.loading = true;

      let url = `InventoryDetail/SetActiveSell/${this.thisStock?.id}`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `SetActiveSell`);
          if (result.data) {
            this.modalSuccessConfirm = true;
            let foundedButton = this.action.buttons.find(
              (current) =>
                current.name == 'deactiveDirectSell' ||
                current.name == 'activeDirectSell'
            );
            if (result.data.isActiveDirectSell && foundedButton != null) {
              foundedButton.name = 'deactiveDirectSell';
              foundedButton.className = 'btn-outline-danger';
              foundedButton.icon = 'far fa-window-close';
            } else if (foundedButton != null) {
              foundedButton.name = 'activeDirectSell';
              foundedButton.className = 'btn-outline-success';
              foundedButton.icon = 'far fa-check-square';
            }
          } else {
            this.apiService.AddErrorLog(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public generateUrl() {
    this.endPointUrl = `InventoryDetail/ListFilter/${this.thisStock?.id}?pageNumber=${this.requestModel.pageNumber}&pageSize=${this.requestModel.pageSize}&paging=${this.requestModel.paging}&orderBy=${this.requestModel.orderBy}&direction=${this.requestModel.direction}&search=${this.requestModel.search}`;
  }

  public generateButtonUrl() {
    this.endPointUrl = `InventoryDetail/${this.thisStock?.id}?pageNumber=${this.requestModel.pageNumber}&pageSize=${this.requestModel.pageSize}&paging=${this.requestModel.paging}&orderBy=${this.requestModel.orderBy}&direction=${this.requestModel.direction}&search=${this.requestModel.search}`;
  }

  public openModal() {
    try {
      this.modalService
        .open(this.modalContent, { ariaLabelledBy: 'modal-basic-title' })
        .result.then(
          (result) => {
            if (result == 'Save click') {
            }
          },
          (reason) => {}
        );
    } catch (error) {
      this.logger.addException(error, false);
    }
  }
}
